import { Database } from "firebase/database";
import React from "react";

import { useIsSignedIn } from "./auth/useIsSignedIn";

const FirebaseDatabaseContext = React.createContext<Database | undefined>(
  undefined,
);

export function FirebaseDatabaseProvider(
  props: React.PropsWithChildren<{ sdk: Database }>,
) {
  return <FirebaseDatabaseContext.Provider value={props.sdk} {...props} />;
}

export function useFirebaseDatabase(): Database {
  const database = React.useContext(FirebaseDatabaseContext);
  if (!database) {
    throw new Error(
      "useFirebaseDatabase must be called from within a FirebaseDatabaseProvider",
    );
  }
  return database;
}

/** The database once Firebase is signed in for the current account; reads made before that are denied by its rules. */
export function useSignedInFirebaseDatabase() {
  const database = useFirebaseDatabase();
  return useIsSignedIn() ? database : undefined;
}
